import React, { Component } from 'react';

import { Form, Col } from 'react-bootstrap';
class Education extends Component {
    render() {
        const [parentState, setParentState] = this.props.state
        return (
            <div className="workContainer">
                <Form>
                    <div className="indivContainer">
                        <h5>Graduation</h5>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>Institute Name</Form.Label>
                                <Form.Control
                                    value={parentState.grad.instName}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.grad.instName = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. College Name" />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>University</Form.Label>
                                <Form.Control
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.grad.univ = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    value={parentState.grad.univ}
                                    type="text" required placeholder="eg. University" />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>
                            <Form.Group as={Col} lg={4} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>Programme Name</Form.Label>

                                <Form.Control
                                    value={parentState.grad.progname}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.grad.progname = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. B.E Computer Engineering" />
                            </Form.Group>

                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Year of Passing</Form.Label>
                                <Form.Control
                                    value={parentState.grad.yop}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.grad.yop = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. 2020" />
                            </Form.Group>

                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    value={parentState.grad.state}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.grad.state = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. State" />
                            </Form.Group>
                        </Form.Row>

                    </div>
                    <div className="indivContainer">
                        <h5>HSSC [Class 12<sup>th</sup>] / Diploma</h5>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>Institute Name</Form.Label>
                                <Form.Control
                                    value={parentState.hssc.instName}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.hssc.instName = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. School" />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Board</Form.Label>
                                <Form.Control
                                    value={parentState.hssc.univ}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.hssc.univ = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. CBSE" />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>
                        <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Stream</Form.Label>
                                <Form.Control
                                    value={parentState.hssc.stream}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.hssc.stream = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. Science/Mechanical..." />
                            </Form.Group>
                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Year of Passing</Form.Label>
                                <Form.Control
                                    value={parentState.hssc.yop}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.hssc.yop = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. 2020" />
                            </Form.Group>

                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    value={parentState.hssc.state}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.hssc.state = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. State" />
                            </Form.Group>
                        </Form.Row>
                    </div>
                    <div className="indivContainer">
                        <h5>SSC [Class 10<sup>th</sup>]</h5>
                        <Form.Row>
                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>Institute Name</Form.Label>
                                <Form.Control
                                    value={parentState.ssc.instName}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.ssc.instName = e.target.value
                                        setParentState({ education: newState })
                                    }}

                                    type="text" required placeholder="eg. State" />
                            </Form.Group>

                            <Form.Group as={Col} lg={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Board</Form.Label>
                                <Form.Control
                                    value={parentState.ssc.univ}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.ssc.univ = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. CBSE" />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>

                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Year of Passing</Form.Label>
                                <Form.Control
                                    value={parentState.ssc.yop}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.ssc.yop = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. 2020" />
                            </Form.Group>

                            <Form.Group as={Col} lg={4} md={6} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    value={parentState.ssc.state}
                                    onChange={(e) => {
                                        const newState = { ...parentState }
                                        newState.ssc.state = e.target.value
                                        setParentState({ education: newState })
                                    }}
                                    type="text" required placeholder="eg. Goa" />
                            </Form.Group>
                        </Form.Row>
                    </div>

                </Form>

            </div>
        )
    }
}

export default Education;